"use strict";

const RainforestPort = {
  add: function (app) {
    const insertScriptTag = (rainforestEnv) => {
      const paymentScript = document.createElement("script");
      const merchantScript = document.createElement("script");

      if (rainforestEnv === "production") {
        paymentScript.src = "https://static.rainforestpay.com/payment.js";
        merchantScript.src = "https://static.rainforestpay.com/merchant.js";
      } else {
        paymentScript.src =
          "https://static.rainforestpay.com/sandbox.payment.js";
        merchantScript.src =
          "https://static.rainforestpay.com/sandbox.merchant.js";
      }

      document.body.appendChild(paymentScript);
      document.body.appendChild(merchantScript);
    };

    // Cross browser support
    const requestAnimationFrame =
      window.requestAnimationFrame ||
      window.mozRequestAnimationFrame ||
      window.webkitRequestAnimationFrame ||
      window.msRequestAnimationFrame;

    app.ports.rainforestPortLoad.subscribe(function (rainforestEnv1) {
      requestAnimationFrame(function () {
        insertScriptTag(rainforestEnv1);
      });
    });

    app.ports.rainforestSubmitPaymentMethod.subscribe(function () {
      const component = document.getElementsByTagName("rainforest-payment")[0];
      if (!component) {
        return;
      }

      component.submit();
    });
  },
};

module.exports = RainforestPort;
